var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCorporateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_Corporate_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Corporate_icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle",
    stroke: "#FF5000",
    strokeWidth: 2,
    points: "3 3 20 3 20 5.134602"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle",
    stroke: "#FF5000",
    strokeWidth: 2,
    transform: "translate(11.500000, 11.568453) scale(1, -1) translate(-11.500000, -11.568453) ",
    points: "3 21.134602 3 2.00230408 20 2.00230408 20 7.80070485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,11.5115055 C12.4812849,11.9565064 16.1300104,10.246473 17.382261,8 L24,8 C22.009476,13.3646602 15.803942,16.7256233 6,16.2657802 L6,11.5115055 Z",
    id: "Fill-10",
    fill: "#FF5000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCorporateIcon);
export default __webpack_public_path__ + "static/media/ico_Corporate_icon.3d7e1bea1e49bf3cec1ed86f31252fad.svg";
export { ForwardRef as ReactComponent };